import { Grid } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { Button, Confirm, Create, Datagrid, Edit, EditButton, Filter, FormDataConsumer, Labeled, List, RadioButtonGroupInput, required, SaveButton, SelectInput, Show, ShowButton, SimpleForm, TextField, TextInput, Toolbar, TopToolbar, useDataProvider, useNotify, useRecordContext } from "react-admin";
import { Link } from "react-router-dom";
import { PopupboxContainer } from "react-popupbox";
import { IMPaidIconList } from "./components/paid-icon-list";

const ListActions = () => (
  <TopToolbar>
    <Button
      color="primary"
      component={Link}
      to={{
        pathname: `/im-paid-icon-packs/create`,
      }}
      label="+ CREATE"
    />
  </TopToolbar>
);

const ListFilter = (props) => {
  const { types } = usePaidIconPackTypes();

  return (
    <Filter {...props}>
      <TextInput label="Paid Icon Pack ID" source="id" alwaysOn />
      <TextInput label="Paid Icon Pack Name" source="name" alwaysOn />
      <SelectInput label="Type" source="type" choices={types} alwaysOn />
      <SelectInput
        label="Status"
        source="enabled"
        choices={[
          { id: true, name: "Enabled" },
          { id: false, name: "Disabled" },
        ]}
        alwaysOn
      />
    </Filter>
  );
};

const StatusField = () => {
  const record = useRecordContext();

  if (record.enabled) {
    return <span style={{ color: "red" }}>Enabled</span>;
  } else {
    return <span>Disabled</span>;
  }
};

const EnableButton = () => {
  const dataProvider = useDataProvider();
  const [showConfirm, setShowConfirm] = React.useState(false);
  const record = useRecordContext();
  const notify = useNotify();

  return (
    <React.Fragment>
      <Button
        label="Enable"
        disabled={record.enabled}
        onClick={() => {
          setShowConfirm(true);
        }}
      />
      <Confirm
        isOpen={showConfirm}
        title="Are you sure you want to enable the super icon pack?"
        onConfirm={async () => {
          try {
            await dataProvider.updatePaidIconPackStatus(record.id, true);
            window.location.reload(true);
          } catch (error) {
            notify(error.message.toString(), "warning");
          }

          setShowConfirm(false);
        }}
        onClose={() => {
          setShowConfirm(false);
        }}
      />
    </React.Fragment>
  );
};

const DisableButton = () => {
  const dataProvider = useDataProvider();
  const [showConfirm, setShowConfirm] = React.useState(false);
  const record = useRecordContext();
  const notify = useNotify();

  return (
    <React.Fragment>
      <Button
        label="Disable"
        disabled={!record.enabled}
        onClick={() => {
          setShowConfirm(true);
        }}
      />
      <Confirm
        isOpen={showConfirm}
        title="Are you sure you want to disable the super icon pack?"
        onConfirm={async () => {
          try {
            await dataProvider.updatePaidIconPackStatus(record.id, false);
            window.location.reload(true);
          } catch (error) {
            notify(error.message.toString(), "warning");
          }

          setShowConfirm(false);
        }}
        onClose={() => {
          setShowConfirm(false);
        }}
      />
    </React.Fragment>
  );
};

const IMPaidIconTitle = ({ record }) => {
  return <span>Paid Icon {record ? `${record.id}` : ""}</span>;
};

const EditToolbar = (props) => (
  <Toolbar
    {...props}
    style={{
      flex: 1,
      display: "flex",
      justifyContent: "space-between",
    }}
  >
    <SaveButton />
    {/* <CustomDelete /> */}
  </Toolbar>
);

export const IMPaidIconPackList = (props) => (
  <List {...props} sort={{ field: "created_at", order: "DESC" }} bulkActionButtons={false} filters={<ListFilter />} actions={<ListActions />} pagination={false}>
    <Datagrid>
      <TextField source="id" label="Paid Icon Pack ID" />
      <TextField source="name" label="Paid Icon Pack Name" />
      <TextField source="type_name" label="Type" />
      <StatusField label="Status" {...props} />
      <EnableButton {...props} />
      <DisableButton {...props} />
      <ShowButton />
      <EditButton />
      {/* <CustomEdit />
      <CustomDelete /> */}
    </Datagrid>
  </List>
);

export const IMPaidIconPackEdit = (props) => {
  const notify = useNotify();
  const onFailure = (error) => {
    notify(error.message.toString(), "warning");
  };

  const { types } = usePaidIconPackTypes();
  const choices = types.map((type) => ({ id: type.id, name: type.name }));
  return (
    <>
      <Edit {...props} onFailure={onFailure} mutationMode="pessimistic" title={<IMPaidIconTitle />}>
        <SimpleForm toolbar={<EditToolbar />}>
          <Grid container spacing={1} fullWidth>
            <Grid item xs={12} sm={12} md={12}>
              <TextInput source="name" label="Paid Icon pack name" validate={required()} fullWidth />
            </Grid>
            <Grid item xs={12} sm={12} md={8}>
              <FormDataConsumer>
                {({ formData }) => {
                  //Disable type if there are icons added
                  const hasIcons = formData.icons.some((icon) => !icon.delete);
                  return <RadioButtonGroupInput fullWidth label="Type" source="type" validate={required()} choices={choices} disabled={hasIcons} />;
                }}
              </FormDataConsumer>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <IMPaidIconList {...props} />
            </Grid>
          </Grid>
        </SimpleForm>
      </Edit>
      <PopupboxContainer />
    </>
  );
};

const usePaidIconPackTypes = () => {
  const dataProvider = useDataProvider();
  const [types, setTypes] = useState([]);

  useEffect(() => {
    dataProvider.getPaidIconPackTypes().then(({ data }) => {
      setTypes(data);
    });
  }, []);

  return { types };
};

// const redirectIMPaidIconPack = () => "/im-paid-icons";
const CreateToolbar = (props) => (
  <Toolbar
    {...props}
    style={{
      flex: 1,
      display: "flex",
      justifyContent: "space-between",
    }}
  >
    <SaveButton label="Save and Continue" />
  </Toolbar>
);

export const IMPaidIconPackCreate = (props) => {
  const notify = useNotify();
  // const redirectTo = useRedirect();

  const onFailure = (error) => {
    notify(error.message.toString(), "warning");
  };
  // const onSuccess = ({ data }) => {
  //   const url = `/im-paid-icons/${data.id}`;
  //   redirectTo(url);
  // };

  const { types } = usePaidIconPackTypes();

  const choices = types.map((type) => ({ id: type.id, name: type.name }));
  const defaultValue = types.find((type) => type.type === "super")?.id;

  return (
    <>
      <Create {...props} onFailure={onFailure}>
        <SimpleForm toolbar={<CreateToolbar />}>
          <Grid container spacing={1} fullWidth>
            <Grid item xs={12} sm={12} md={12}>
              <TextInput source="name" label="Paid Icon pack name" validate={required()} fullWidth />
            </Grid>
            <Grid item xs={12} sm={12} md={8}>
              <RadioButtonGroupInput fullWidth label="Type" source="type" validate={required()} choices={choices} defaultValue={defaultValue} />
            </Grid>
          </Grid>
        </SimpleForm>
      </Create>
      <PopupboxContainer />
    </>
  );
};

export const IMPaidIconPackShow = (props) => {
  return (
    <>
      <Show {...props} title={<IMPaidIconTitle />}>
        <SimpleForm toolbar={null}>
          <Grid container spacing={1} fullWidth>
            <Grid item sm={12} md={6}>
              <Labeled label="Paid Icon pack ID">
                <TextField source="id" fullWidth />
              </Labeled>
            </Grid>
            <Grid item sm={12} md={6}>
              <Labeled label="Paid Icon pack Name">
                <TextField source="name" fullWidth />
              </Labeled>
            </Grid>
            <Grid item sm={12} md={12}>
              <Labeled label="Type">
                <TextField source="type_name" fullWidth />
              </Labeled>
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <IMPaidIconList readonly={true} {...props} />
            </Grid>
          </Grid>
        </SimpleForm>
      </Show>
    </>
  );
};
